export { UserRemove2 as default } from './UserRemove2';
